import clsx from 'clsx';
import CheckServiceButton from './CheckServiceButton';
import { useParams } from 'react-router-dom';
import { ProductCategory } from 'screens/AccessExpressV3/accessExpress.types';

const AlternativeOfferCard = ({
  carrier,
  price,
  image: Image,
  type,
}: {
  carrier: string;
  price: string;
  image: React.ElementType;
  type: 'Broadband' | 'DIA' | 'Starlink' | 'cradlepoint' | null;
}) => {
  const { category: routeCategory } = useParams<{
    category: ProductCategory;
  }>();
  const isAllProducts = routeCategory === 'All';

  return (
    <div className="flex flex-wrap gap-6">
      <div className="flex w-full min-w-[300px] flex-1 flex-col gap-4">
        <h1 className={clsx('text-2xl font-bold text-content-base-default')}>
          {carrier}
        </h1>
        <p className="flex flex-col justify-center font-bold">
          <span className="h-[38px]">
            <span className="flex items-center">
              <span className="text-xs text-content-base-subdued">
                Starting at&nbsp;
              </span>
              <span className="text-xl text-content-base-default">{price}</span>
              <span className=" text-xs text-content-base-subdued">
                &nbsp;/month for 36 months
              </span>
            </span>
          </span>
          <span className="mt-1 text-xs">
            {type === 'DIA' ? '' : '+ equipment'}
          </span>
        </p>
        <CheckServiceButton
          type={type}
          className="max-w-[220px] self-start xl:flex"
          isAllProducts={isAllProducts}
        />
      </div>
      <div className="flex items-center justify-between gap-8">
        <Image className="w-full" />
      </div>
      <CheckServiceButton
        type={type}
        className="mt-3 flex self-end xl:hidden"
        isAllProducts={isAllProducts}
      />
    </div>
  );
};

export default AlternativeOfferCard;
